import React from 'react';
import styles from './FeaturesHeaderSection.module.scss';
import SectionBadge from '../components/SectionBadge';

const FeaturesHeaderSection = () => {
  return (
    <section className={styles.featuresHeader}>
      <div className={styles.container}>
        <SectionBadge>Product features</SectionBadge>
        <h2 className={styles.headline}>
          Boost your growth with AI-built campaigns, viral templates & done-for-you content calendars
        </h2>
      </div>
    </section>
  );
};

export default FeaturesHeaderSection;
